import { Container, Mesh, Program, IcoSphereGeometryBuffer, Texture } from 'beam';
import gridVertexShader from './shaders/grid-vs.glsl'
import gridFragmentShader from './shaders/grid-fs.glsl'
import Emitter from '../core/emitter.js'
import Tween from './helpers/Tween';

export default class GLBackgroundSphere extends HTMLElement {

    constructor() {
        super();
        this.update        = this.update.bind(this);
        this.onImmersiveView = this.onImmersiveView.bind(this);
        this.enterScale = 0;
        this.leaveScale = 0;
    }

    connectedCallback() {
        this.__isConnected__ = true;
        let node = this;
        let i=0;
        while (node.parentNode && i<100) { 
            if (node.parentNode.tagName == 'WEBGL-SCENE') {
                this.$glScene = node.parentNode;
                break;
            }
            node = node.parentNode;
            i++;
        }
        if (!this.$glScene) {
            console.warn('missing <gl-scene> parent node');
            return
        }

        requestAnimationFrame(()=>{
            this.init();
            this.update();
            Emitter.on('immersive-view', this.onImmersiveView);
            this.show()
        })

    }

    onImmersiveView(isImmersiveMode) {
        if (isImmersiveMode) {
            this.hide()
        }
        else {
            this.show()
        }
    }

    init() {

        this.renderer = this.$glScene.renderer;

        this.bgSphereContainer = new Container();
        this.$glScene.addChild(this.bgSphereContainer);
        const bgSphere = new Mesh();
        bgSphere.geometry = new IcoSphereGeometryBuffer(this.renderer.gl, {
            radius:  2000, 
            details: 6,
        }); 
        bgSphere.material = new Program(this.renderer.gl, {
            vertexShader:   gridVertexShader,
            fragmentShader: gridFragmentShader,
            type:           this.renderer.gl.POINTS,
            uniforms: {
                uPointScale: 1,
                uSphere:     1,
            }
        });
        this.bgSphere = bgSphere;
        this.bgSphereContainer.add(this.bgSphere);

    }

    show() {
        this.leaveScale = 0;
        this.enterScale = 0;
        Tween({e:0}, {
            to: {e:1},
            delay: 0, 
            easing:  [0.430, 0.195, 0.020, 1.000],
            duration: 1,
            step: e => {
                this.enterScale = e;
            },
            end: () => {
            }
        });
    }

    hide() {
        this.enterScale = 1;
        this.leaveScale = 0;
        Tween({e:0}, {
            to: {e:1},
            delay: 0, 
            easing:  [0.430, 0.195, 0.020, 1.000],
            duration: 1,
            step: e => {
                this.enterScale = 1 - e;
                this.leaveScale = e * 2;
            },
            end: () => {
         
            }
        });
    }

    update() {

        if (!this.__isConnected__) {
            return;
        }
        requestAnimationFrame(()=>{
            this.update();
        });
        
        this.bgSphereContainer.position[0] = 0;
        this.bgSphereContainer.position[1] = 0;
        this.bgSphere.scale[0] =( (300 / 2000) + (1.5 - 1.5 * 0)  ) ;
        this.bgSphere.scale[1] =( (300 / 2000) + (1.5 - 1.5 * 0)  ) ;
        this.bgSphere.scale[2] =( (300 / 2000) + (1.5 - 1.5 * 0)  ) ;
        this.bgSphere.material.setUniform('uPointScale', (1 - Math.max(0., (0 - 0.75) / 0.25)) * this.enterScale * (1. - this.leaveScale));

        this.bgSphereContainer.rotation[0]  = this.$glScene._scroll/window.innerHeight * 0.5

        this.bgSphere.rotation[1]  = this.enterScale * Math.PI/2 + this.leaveScale * Math.PI/2

        this.bgSphereContainer.updateMatrix()
        this.bgSphereContainer.updateWorldMatrix()
        this.bgSphere.updateMatrix()
        this.bgSphere.updateWorldMatrix()

    }

    disconnectedCallback() {
        this.__isConnected__ = false;
        this.$glScene.removeChild(this.bgSphereContainer);
    }

}

customElements.define('gl-background-sphere', GLBackgroundSphere);